import Alpine from "alpinejs";
import collapse from "@alpinejs/collapse";
import ui from "@alpinejs/ui";
import focus from "@alpinejs/focus";
import { tns } from "tiny-slider/src/tiny-slider";

window.tns = tns

export default function () {
    window.Alpine = Alpine;
    Alpine.plugin(ui);
    Alpine.plugin(collapse);
    Alpine.plugin(focus);
    Alpine.start();

}